function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["className", "placeHolder", "defaultValue", "disabled", "searchable", "prefix", "suffix", "delable", "deleteIcon", "error", "type", "onChange", "onClickInputEle", "onBlur", "onInput", "maxLen", "onPressEnter", "min", "max", "forbidChinese", "filterCharArray"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classNames from 'classnames';
import { Icon } from "./..";
import React, { useEffect, useState } from 'react';
import "./index.less";
var Input = function Input(props) {
  var className = props.className,
    placeHolder = props.placeHolder,
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    searchable = props.searchable,
    prefix = props.prefix,
    suffix = props.suffix,
    delable = props.delable,
    deleteIcon = props.deleteIcon,
    error = props.error,
    type = props.type,
    onChange = props.onChange,
    onClickInputEle = props.onClickInputEle,
    onBlur = props.onBlur,
    _onInput = props.onInput,
    _props$maxLen = props.maxLen,
    maxLen = _props$maxLen === void 0 ? 100 : _props$maxLen,
    onPressEnter = props.onPressEnter,
    min = props.min,
    max = props.max,
    _props$forbidChinese = props.forbidChinese,
    forbidChinese = _props$forbidChinese === void 0 ? false : _props$forbidChinese,
    _props$filterCharArra = props.filterCharArray,
    filterCharArray = _props$filterCharArra === void 0 ? [';', '；', '‘', '’', '_', "'"] : _props$filterCharArra,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(defaultValue || ''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  useEffect(function () {
    if (defaultValue !== undefined && defaultValue !== null) {
      setInputValue(defaultValue);
    }
  }, [defaultValue]);
  // 使用正则表达式判断是否包含中文字符有则删除
  function removeChinese(orgStr) {
    var str = orgStr;
    if (/[\u4E00-\u9FA5]/.test(str)) {
      // 使用replace方法替换掉中文字符
      str = str.replace(/[\u4E00-\u9FA5]/g, '');
    }
    filterCharArray.map(function (i) {
      return str = str.replace(i, '');
    });
    return str;
  }
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    var res = forbidChinese ? removeChinese(value) : value;
    setInputValue(res);
    if (onChange) {
      onChange(res, e);
    }
  };
  var clearValue = function clearValue(e) {
    if (delable) {
      setInputValue('');
    }
    if (onChange) {
      onChange('', e);
    }
  };
  var handleBlur = function handleBlur(e) {
    var value = e.target.value;
    var val = forbidChinese ? removeChinese(value) : value;
    setInputValue(val);
    if (onBlur) {
      onBlur(val, e);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    var value = event.target.value;
    if (event.keyCode === 13) {
      // 13 是回车键的 keyCode
      if (onPressEnter) {
        onPressEnter(value, event);
      }
    }
  };
  var classes = classNames('iron-input-box', className, _defineProperty(_defineProperty({}, "iron-formItem-error", error), "iron-formItem-disabled", disabled));
  return /*#__PURE__*/React.createElement("div", {
    //tabIndex是为了div能用OnBlur（为了搭配使用，修改当前div的css outline：none）
    // tabIndex={-1} // 没理解干嘛的先注释
    onClick: function onClick(e) {
      return onClickInputEle && onClickInputEle(inputValue, e);
    },
    className: classes
  }, searchable && /*#__PURE__*/React.createElement(Icon, {
    name: "circle-cross"
  }), prefix && /*#__PURE__*/React.createElement("div", {
    className: "iron-input-commonfix iron-input-prefix"
  }, prefix), /*#__PURE__*/React.createElement("input", _extends({
    min: min,
    max: max,
    maxLength: maxLen,
    onKeyDown: handleKeyDown,
    placeholder: placeHolder || '',
    className: "iron-input",
    value: inputValue,
    onChange: handleChange,
    onBlur: handleBlur,
    onInput: function onInput(e) {
      var value = e.target.value;
      if (min !== undefined && value < min) return;
      if (max !== undefined && value > max) setInputValue(max.toString());
      //如果传了onInput方法，那就调用
      if (_onInput) {
        _onInput(value, setInputValue);
      }
    },
    disabled: disabled ? true : false,
    type: type || ''
  }, restProps)), delable && (deleteIcon ? /*#__PURE__*/React.createElement("div", {
    onClick: clearValue,
    className: "iron-cursor-pointer"
  }, deleteIcon) : /*#__PURE__*/React.createElement("div", {
    onClick: clearValue,
    className: "iron-cursor-pointer"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "circle-cross",
    className: "iron-del-icon",
    size: "medium"
  }))), suffix && /*#__PURE__*/React.createElement("div", {
    className: "iron-input-commonfix iron-input-suffix"
  }, suffix));
};
export default Input;